import { LANGUAGE } from '@/constants/language'

export const switchLanguage = (locale: string) => {
  return locale === LANGUAGE.THA ? `?lng=${LANGUAGE.ENG}` : ''
}

export const getLocaleParam = (locale: string) => {
  if (!locale) return ''
  return locale === LANGUAGE.ENG ? `?lng=${locale}` : ''
}
